import React from 'react';
import { Box, Heading, Link } from '@chakra-ui/react';

const Resume = ({ bg, color }) => (
    <Box id="resume" p={5} bg={bg} borderRadius="lg" boxShadow="md">
        <Heading as="h2" size="lg" color={color}>Resume</Heading>
        <Link href="https://drive.google.com/file/d/1kS4QjwAFj_IA8E1hxik1AUVuce2Z01yH/view" color="teal.500" isExternal mt={4}>View and Download Resume</Link>
    </Box>
);

export default Resume;
